module.exports = __webpack_public_path__ + "img/xinwen9.23cad037.jpg";